import { create } from 'zustand';
import { broadcast, onSessionMessage, SESSION_MSG } from '../lib/sessionChannel';

const DEFAULTS = {
  company_name: 'NexAdvantage',
  company_subtitle: 'WorkFlow Manager',
  logo_url: '',
  logo_icon_letter: 'N',
  footer_text: '© {year} NexAdvantage S.r.l. · Tutti i diritti riservati',
  login_background_color: '#0E233E',
  primary_color: '#183860',
  accent_color: '#E5202A',
};

export { DEFAULTS as BRANDING_DEFAULTS };

export const useBrandingStore = create((set) => ({
  branding: { ...DEFAULTS },
  loaded: false,

  fetchBranding: async () => {
    try {
      const res = await fetch('/branding', { cache: 'no-store' });
      if (res.ok) {
        const body = await res.json();
        set({ branding: body.data || DEFAULTS, loaded: true });
      } else {
        set({ loaded: true });
      }
    } catch (_) {
      set({ loaded: true });
    }
  },

  // Call after saving anything under /branding. The security settings live
  // here too, and SessionGuard + SessionTimerBadge read the inactivity
  // timeout straight from this store: without a refresh the save changed the
  // database and nothing else, so the running app kept counting down with the
  // OLD value while telling the admin the change was "attiva immediatamente".
  // Broadcast so every other open window picks it up as well, instead of each
  // one honouring a stale setting until someone reloads it.
  refreshBranding: async () => {
    await useBrandingStore.getState().fetchBranding();
    broadcast(SESSION_MSG.settings, {});
  },
}));

if (typeof window !== 'undefined') {
  onSessionMessage(SESSION_MSG.settings, () => {
    useBrandingStore.getState().fetchBranding();
  });
}
